export default "__VITE_ASSET__8ef60019__"